import {toast} from "react-toastify";

const GlobalNotificationPopup = ({type = "success", message = null}) => {
  // Map type to specific toast method
  const showToast = () => {
    switch (type) {
      case "success":
        return toast.success(message);
      case "error":
        return toast.error(message);
      case "info":
        return toast.info(message);
      case "warning":
        return toast.warning(message);
      default:
        return toast(message); // Default toast if type is not recognized
    }
  };

  return showToast();
};

export default GlobalNotificationPopup;
